import { jsx, jsxs } from "react/jsx-runtime";
import { FormControl, FormHelperText } from "@mui/material";
import {
  DynamicList as DynamicListComponent
} from "../../../../components/DynamicList/index.js";
import { useFormField } from "../../../core/useFormField/useFormField.js";
import { useErrorHelper } from "../../utils/useErrorHelper.js";
import { useValidateOn } from "../../utils/useValidateOn.js";
import { useActions } from "./hooks/useActions.js";
import { useErrorsByChild } from "./hooks/useErrorsByChild.js";
const defaultComponentValue = [];
function DynamicList(props) {
  const {
    name,
    testId,
    fullWidth,
    helperText,
    validateOn = "change",
    defaultValue,
    initialValue = defaultComponentValue,
    errorVisibility = "all",
    dynamicListProps,
    ...options
  } = props;
  const {
    field: { value, visible, status },
    errors: fieldErrors,
    fieldApi
  } = useFormField(name, { ...options, initialValue });
  const { validateOnChange } = useValidateOn(fieldApi.validate, validateOn);
  const { addItem, deleteItem, changeItem, swapItems, clearItems } = useActions(
    // @ts-expect-error // FIXME: improve this type definition
    defaultValue,
    validateOnChange,
    fieldApi
  );
  const { showErrorAccent, showHelperText, fieldHasError, errorOrHelperText } = useErrorHelper(
    fieldErrors,
    errorVisibility,
    helperText,
    status
  );
  const errorsByChild = useErrorsByChild(fieldErrors);
  if (!visible) return null;
  return /* @__PURE__ */ jsxs(
    FormControl,
    {
      error: showErrorAccent && fieldHasError,
      fullWidth,
      "data-testid": testId,
      "data-tidal": "DynamicList",
      "data-tidal-form-field-name": name,
      sx: {
        "&.tidal-form-devtool-highlight": (theme) => ({
          outline: `4px solid var(--tidal-devtools-highlight-color, ${theme.vars.palette.error.dark})`
        })
      },
      children: [
        /* @__PURE__ */ jsx(
          DynamicListComponent,
          {
            ...dynamicListProps,
            value,
            errors: errorsByChild,
            testId,
            addItem,
            swapItems,
            deleteItem,
            changeItem,
            clearItems
          }
        ),
        showHelperText && /* @__PURE__ */ jsx(FormHelperText, { error: fieldHasError, children: errorOrHelperText })
      ]
    }
  );
}
export {
  DynamicList
};
//# sourceMappingURL=DynamicList.js.map
